// Generated M layer lookup table
// Contains flattened taxonomy for Moves

export const M_LAYER_LOOKUP = {
  POP: {
    numericCode: '001',
    name: 'Pop_Dance',
  },
  'POP.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'POP.DIS': {
    numericCode: '002',
    name: 'Disco',
  },
  'POP.JZF': {
    numericCode: '003',
    name: 'Jazz_Funk',
  },
  'POP.HPL': {
    numericCode: '004',
    name: 'Hip_Hop_Lite',
  },
  'POP.CNT': {
    numericCode: '005',
    name: 'Contemporary_Pop',
  },
  'POP.FRE': {
    numericCode: '006',
    name: 'Freestyle_Club',
  },
  'POP.VOG': {
    numericCode: '007',
    name: 'Vogue',
  },
  JZZ: {
    numericCode: '002',
    name: 'Jazz_Dance',
  },
  'JZZ.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'JZZ.JZD': {
    numericCode: '002',
    name: 'Jazz_Dance',
  },
  'JZZ.TAP': {
    numericCode: '003',
    name: 'Tap',
  },
  'JZZ.LND': {
    numericCode: '004',
    name: 'Lindy_Hop',
  },
  'JZZ.BEB': {
    numericCode: '005',
    name: 'Bebop',
  },
  HIP: {
    numericCode: '003',
    name: 'Hip_Hop_Dance',
  },
  'HIP.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'HIP.BRK': {
    numericCode: '002',
    name: 'Breakdance',
  },
  'HIP.POP': {
    numericCode: '003',
    name: 'Popping',
  },
  'HIP.LCK': {
    numericCode: '004',
    name: 'Locking',
  },
  'HIP.KRM': {
    numericCode: '005',
    name: 'Krumping',
  },
  'HIP.HSE': {
    numericCode: '006',
    name: 'House',
  },
  LAT: {
    numericCode: '004',
    name: 'Latin_Dance',
  },
  'LAT.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'LAT.SAL': {
    numericCode: '002',
    name: 'Salsa',
  },
  'LAT.TNG': {
    numericCode: '003',
    name: 'Tango',
  },
  'LAT.RUM': {
    numericCode: '004',
    name: 'Rumba',
  },
  'LAT.CHA': {
    numericCode: '005',
    name: 'Cha_Cha',
  },
  'LAT.BCH': {
    numericCode: '006',
    name: 'Bachata',
  },
  EDM: {
    numericCode: '005',
    name: 'EDM_Dance',
  },
  'EDM.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'EDM.HSE': {
    numericCode: '002',
    name: 'House',
  },
  'EDM.SHF': {
    numericCode: '003',
    name: 'Shuffling',
  },
  'EDM.DUB': {
    numericCode: '004',
    name: 'Dubstep',
  },
  'EDM.TRN': {
    numericCode: '005',
    name: 'Trance',
  },
  RCK: {
    numericCode: '006',
    name: 'Rock_Dance',
  },
  'RCK.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'RCK.RNR': {
    numericCode: '002',
    name: 'Rock_n_Roll',
  },
  'RCK.DIS': {
    numericCode: '003',
    name: 'Disco',
  },
  'RCK.CNT': {
    numericCode: '004',
    name: 'Contemporary',
  },
  RNB: {
    numericCode: '007',
    name: 'RnB_Dance',
  },
  'RNB.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'RNB.SMG': {
    numericCode: '002',
    name: 'Smooth_Groove',
  },
  'RNB.FNK': {
    numericCode: '003',
    name: 'Funk',
  },
  BOL: {
    numericCode: '008',
    name: 'Bollywood_Dance',
  },
  'BOL.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'BOL.CLS': {
    numericCode: '002',
    name: 'Classical',
  },
  'BOL.MOD': {
    numericCode: '003',
    name: 'Modern',
  },
  'BOL.FUS': {
    numericCode: '004',
    name: 'Fusion',
  },
  JPO: {
    numericCode: '009',
    name: 'J_Pop_Dance',
  },
  'JPO.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'JPO.IDL': {
    numericCode: '002',
    name: 'Idol_Dance',
  },
  'JPO.VSK': {
    numericCode: '003',
    name: 'Visual_Kei',
  },
  'JPO.KAW': {
    numericCode: '004',
    name: 'Kawaii',
  },
  TRD: {
    numericCode: '010',
    name: 'Traditional_Dance',
  },
  'TRD.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'TRD.FLK': {
    numericCode: '002',
    name: 'Folk',
  },
  'TRD.CUL': {
    numericCode: '003',
    name: 'Cultural',
  },
  CNT: {
    numericCode: '011',
    name: 'Contemporary_Dance',
  },
  'CNT.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'CNT.LYR': {
    numericCode: '002',
    name: 'Lyrical',
  },
  'CNT.MOD': {
    numericCode: '003',
    name: 'Modern',
  },
  CLS: {
    numericCode: '012',
    name: 'Classic_Choreography',
  },
  'CLS.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'CLS.BAL': {
    numericCode: '002',
    name: 'Ballet',
  },
  'CLS.TNG': {
    numericCode: '003',
    name: 'Tango',
  },
  STR: {
    numericCode: '013',
    name: 'Street_Dance',
  },
  'STR.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'STR.BRK': {
    numericCode: '002',
    name: 'Breakdance',
  },
  'STR.POP': {
    numericCode: '003',
    name: 'Popping',
  },
  CUL: {
    numericCode: '014',
    name: 'Cultural_Dance',
  },
  'CUL.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'CUL.AFR': {
    numericCode: '002',
    name: 'African',
  },
  'CUL.IND': {
    numericCode: '003',
    name: 'Indian',
  },
  FAN: {
    numericCode: '015',
    name: 'Fantasy_Dance',
  },
  'FAN.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'FAN.MED': {
    numericCode: '002',
    name: 'Medieval',
  },
  'FAN.FAI': {
    numericCode: '003',
    name: 'Fairy',
  },
  MVM: {
    numericCode: '016',
    name: 'Movement_Mechanics',
  },
  'MVM.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'MVM.ISO': {
    numericCode: '002',
    name: 'Isolations',
  },
  'MVM.WAV': {
    numericCode: '003',
    name: 'Waves',
  },
  'MVM.FTW': {
    numericCode: '004',
    name: 'Footwork',
  },
  'MVM.SPN': {
    numericCode: '005',
    name: 'Spins',
  },
  'MVM.JMP': {
    numericCode: '006',
    name: 'Jumps',
  },
  'MVM.FLW': {
    numericCode: '007',
    name: 'Floor_Work',
  },
  'MVM.EXT': {
    numericCode: '008',
    name: 'Extensions',
  },
  'MVM.BAL': {
    numericCode: '009',
    name: 'Balance',
  },
  'MVM.CTR': {
    numericCode: '010',
    name: 'Contraction_Release',
  },
  SMT: {
    numericCode: '017',
    name: 'Social_Media_Trending',
  },
  'SMT.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'SMT.WOH': {
    numericCode: '002',
    name: 'Woah',
  },
  'SMT.REN': {
    numericCode: '003',
    name: 'Renegade',
  },
  'SMT.SAV': {
    numericCode: '004',
    name: 'Savage',
  },
  'SMT.SSO': {
    numericCode: '005',
    name: 'Say_So',
  },
  'SMT.SME': {
    numericCode: '006',
    name: 'Smeeze',
  },
  'SMT.GRD': {
    numericCode: '007',
    name: 'GriddyDance',
  },
  'SMT.HYP': {
    numericCode: '008',
    name: 'HypeMan',
  },
  'SMT.SHT': {
    numericCode: '009',
    name: 'Shoot',
  },
  'SMT.MIL': {
    numericCode: '010',
    name: 'Milly_Rock',
  },
  'SMT.DOU': {
    numericCode: '011',
    name: 'Dougie',
  },
  'SMT.CKH': {
    numericCode: '012',
    name: 'ChickenHead',
  },
  KPC: {
    numericCode: '018',
    name: 'KPop_Choreography',
  },
  'KPC.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'KPC.PND': {
    numericCode: '002',
    name: 'Point_Dance',
  },
  'KPC.FRC': {
    numericCode: '003',
    name: 'Formation_Change',
  },
  'KPC.SHM': {
    numericCode: '004',
    name: 'Sharp_Movements',
  },
  'KPC.SYG': {
    numericCode: '005',
    name: 'Synchronized_Group',
  },
  'KPC.FLP': {
    numericCode: '006',
    name: 'Floor_Patterns',
  },
  'KPC.KLP': {
    numericCode: '007',
    name: 'Killing_Part',
  },
  'KPC.FNS': {
    numericCode: '008',
    name: 'Fan_Service',
  },
  'KPC.TUT': {
    numericCode: '009',
    name: 'Tutting',
  },
  'KPC.VOG': {
    numericCode: '010',
    name: 'Vogue_Inspired',
  },
  GLC: {
    numericCode: '019',
    name: 'Global_Cultural',
  },
  'GLC.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'GLC.BHA': {
    numericCode: '002',
    name: 'Bharatanatyam',
  },
  'GLC.KAT': {
    numericCode: '003',
    name: 'Kathak',
  },
  'GLC.FLM': {
    numericCode: '004',
    name: 'Flamenco',
  },
  'GLC.CAP': {
    numericCode: '005',
    name: 'Capoeira',
  },
  'GLC.HUL': {
    numericCode: '006',
    name: 'Hula',
  },
  'GLC.LIO': {
    numericCode: '007',
    name: 'Lion_Dance',
  },
  'GLC.IRS': {
    numericCode: '008',
    name: 'Irish_Step',
  },
  'GLC.AFT': {
    numericCode: '009',
    name: 'African_Tribal',
  },
  'GLC.MDE': {
    numericCode: '010',
    name: 'Middle_Eastern',
  },
  'GLC.POL': {
    numericCode: '011',
    name: 'Polynesian',
  },
  MOD: {
    numericCode: '020',
    name: 'Mood_Based',
  },
  'MOD.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'MOD.JOY': {
    numericCode: '002',
    name: 'Joyful',
  },
  'MOD.MEL': {
    numericCode: '003',
    name: 'Melancholic',
  },
  'MOD.AGG': {
    numericCode: '004',
    name: 'Aggressive',
  },
  'MOD.SEN': {
    numericCode: '005',
    name: 'Sensual',
  },
  'MOD.POW': {
    numericCode: '006',
    name: 'Powerful',
  },
  'MOD.ETH': {
    numericCode: '007',
    name: 'Ethereal',
  },
  'MOD.PLA': {
    numericCode: '008',
    name: 'Playful',
  },
  TEC: {
    numericCode: '021',
    name: 'Technical_Elements',
  },
  'TEC.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'TEC.TRN': {
    numericCode: '002',
    name: 'Turns',
  },
  'TEC.LEA': {
    numericCode: '003',
    name: 'Leaps',
  },
  'TEC.EXT': {
    numericCode: '004',
    name: 'Extensions',
  },
  'TEC.BAL': {
    numericCode: '005',
    name: 'Balances',
  },
  'TEC.FLW': {
    numericCode: '006',
    name: 'Floorwork',
  },
  'TEC.PRT': {
    numericCode: '007',
    name: 'Partnering',
  },
  'TEC.LFT': {
    numericCode: '008',
    name: 'Lifts',
  },
  'TEC.INV': {
    numericCode: '009',
    name: 'Inversions',
  },
  URB: {
    numericCode: '022',
    name: 'Urban_Elements',
  },
  'URB.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'URB.TOP': {
    numericCode: '002',
    name: 'Top_Rock',
  },
  'URB.FTW': {
    numericCode: '003',
    name: 'Footwork',
  },
  'URB.PWR': {
    numericCode: '004',
    name: 'Power_Moves',
  },
  'URB.FRZ': {
    numericCode: '005',
    name: 'Freezes',
  },
  'URB.THR': {
    numericCode: '006',
    name: 'Threading',
  },
  'URB.WAV': {
    numericCode: '007',
    name: 'Waving',
  },
  'URB.GLD': {
    numericCode: '008',
    name: 'Gliding',
  },
  'URB.TUT': {
    numericCode: '009',
    name: 'Tutting',
  },
  'URB.HIT': {
    numericCode: '010',
    name: 'Hitting',
  },
  AFB: {
    numericCode: '023',
    name: 'Afrobeats_Dance',
  },
  'AFB.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'AFB.AZN': {
    numericCode: '002',
    name: 'Azonto',
  },
  'AFB.SHK': {
    numericCode: '003',
    name: 'Shaku_Shaku',
  },
  'AFB.AMG': {
    numericCode: '004',
    name: 'Amapiano',
  },
};

export const M_SUBCATEGORIES = {
  POP: [
    'POP.BAS',
    'POP.DIS',
    'POP.JZF',
    'POP.HPL',
    'POP.CNT',
    'POP.FRE',
    'POP.VOG',
  ],
  JZZ: ['JZZ.BAS', 'JZZ.JZD', 'JZZ.TAP', 'JZZ.LND', 'JZZ.BEB'],
  HIP: ['HIP.BAS', 'HIP.BRK', 'HIP.POP', 'HIP.LCK', 'HIP.KRM', 'HIP.HSE'],
  LAT: ['LAT.BAS', 'LAT.SAL', 'LAT.TNG', 'LAT.RUM', 'LAT.CHA', 'LAT.BCH'],
  EDM: ['EDM.BAS', 'EDM.HSE', 'EDM.SHF', 'EDM.DUB', 'EDM.TRN'],
  RCK: ['RCK.BAS', 'RCK.RNR', 'RCK.DIS', 'RCK.CNT'],
  RNB: ['RNB.BAS', 'RNB.SMG', 'RNB.FNK'],
  BOL: ['BOL.BAS', 'BOL.CLS', 'BOL.MOD', 'BOL.FUS'],
  JPO: ['JPO.BAS', 'JPO.IDL', 'JPO.VSK', 'JPO.KAW'],
  TRD: ['TRD.BAS', 'TRD.FLK', 'TRD.CUL'],
  CNT: ['CNT.BAS', 'CNT.LYR', 'CNT.MOD'],
  CLS: ['CLS.BAS', 'CLS.BAL', 'CLS.TNG'],
  STR: ['STR.BAS', 'STR.BRK', 'STR.POP'],
  CUL: ['CUL.BAS', 'CUL.AFR', 'CUL.IND'],
  FAN: ['FAN.BAS', 'FAN.MED', 'FAN.FAI'],
  MVM: [
    'MVM.BAS',
    'MVM.ISO',
    'MVM.WAV',
    'MVM.FTW',
    'MVM.SPN',
    'MVM.JMP',
    'MVM.FLW',
    'MVM.EXT',
    'MVM.BAL',
    'MVM.CTR',
  ],
  SMT: [
    'SMT.BAS',
    'SMT.WOH',
    'SMT.REN',
    'SMT.SAV',
    'SMT.SSO',
    'SMT.SME',
    'SMT.GRD',
    'SMT.HYP',
    'SMT.SHT',
    'SMT.MIL',
    'SMT.DOU',
    'SMT.CKH',
  ],
  KPC: [
    'KPC.BAS',
    'KPC.PND',
    'KPC.FRC',
    'KPC.SHM',
    'KPC.SYG',
    'KPC.FLP',
    'KPC.KLP',
    'KPC.FNS',
    'KPC.TUT',
    'KPC.VOG',
  ],
  GLC: [
    'GLC.BAS',
    'GLC.BHA',
    'GLC.KAT',
    'GLC.FLM',
    'GLC.CAP',
    'GLC.HUL',
    'GLC.LIO',
    'GLC.IRS',
    'GLC.AFT',
    'GLC.MDE',
    'GLC.POL',
  ],
  MOD: [
    'MOD.BAS',
    'MOD.JOY',
    'MOD.MEL',
    'MOD.AGG',
    'MOD.SEN',
    'MOD.POW',
    'MOD.ETH',
    'MOD.PLA',
  ],
  TEC: [
    'TEC.BAS',
    'TEC.TRN',
    'TEC.LEA',
    'TEC.EXT',
    'TEC.BAL',
    'TEC.FLW',
    'TEC.PRT',
    'TEC.LFT',
    'TEC.INV',
  ],
  URB: [
    'URB.BAS',
    'URB.TOP',
    'URB.FTW',
    'URB.PWR',
    'URB.FRZ',
    'URB.THR',
    'URB.WAV',
    'URB.GLD',
    'URB.TUT',
    'URB.HIT',
  ],
  AFB: ['AFB.BAS', 'AFB.AZN', 'AFB.SHK', 'AFB.AMG'],
};
